<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const props = withDefaults(defineProps<{
  label?: string
  minHeight?: number | string
  customClass?: string
  showLabel?: boolean
  ariaBusy?: boolean
}>(), {
  ariaBusy: false,
  customClass: '',
  label: '',
  minHeight: 180,
  showLabel: true,
})

const { t } = useI18n()

const labelText = computed(() => props.label || t('CARREGANDO'))

const rootStyle = computed(() => {
  if (props.minHeight == null || props.minHeight === '')
    return undefined

  const height = typeof props.minHeight === 'number' ? `${props.minHeight}px` : props.minHeight
  return { minHeight: height }
})
</script>

<template>
  <div
    class="v3-loading-state"
    :class="customClass"
    :style="rootStyle"
    role="status"
    aria-live="polite"
    :aria-busy="ariaBusy"
  >
    <span class="v3-loading-state__spinner" aria-hidden="true">
      <div class="i-tabler-loader-2 animate-spin text-4" />
    </span>
    <span v-if="showLabel" class="v3-loading-state__label">{{ labelText }}</span>
  </div>
</template>

<style lang="scss" scoped>
.v3-loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: var(--v3-loading-text-muted, rgba(248, 250, 252, 0.55));
  font-family: 'MontserratLight', sans-serif;
  font-size: 13px;

  &__spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(217, 153, 30, 0.14);
    color: var(--v3-loading-accent, #d9991e);
  }

  &__label {
    text-align: center;
  }
}
</style>
